import { Skeleton } from '@mui/material';

function HeaderBookingNumberLoader(): JSX.Element {
  return <Skeleton variant="text" width={'276px'} height={'36px'} />;
}

export default HeaderBookingNumberLoader;
